export default {
  defaultLayer: "Evapotranspiration",

  head: [
    {
      name: "NHP Home",
      path: "/",
      active: true,
    },
    {
      name: "Training Home",
      path: "/trainingnew",
      active: true,
    },
    {
      name: "Objective",
      path: "/trainingnew/proj-obj",
    },
    // {
    //     name:"Technical Proposal",
    //     path:"/trainingNew/tech-prop"

    // },
    // {
    //     name:"Project Team",
    //     path:"/trainingNew/proj-team"

    // },

    {
      name: "Courses",
      path: "/trainingnew/courses",
    },

    // {

    //     name:"menu 3",
    //     path:"/"
    // },
  ],

  breadCrumbs: [
    {
      name: "menu 1",
      path: "/",
    },
    {
      name: "menu 2",
      path: "/",
    },
    {
      name: "menu 3",
      path: "/",
    },
  ],

  mapSideBar: [
    {
      id: 5,
      name: "Evapotranspiration",
      icon: "stroopwafel",
      ismap: true,
      default: true,
    },
    // {
    //     "id": 3,
    //     "name": 'Net Radiation',
    //     "icon":"stroopwafel",
    //     "ismap":true,

    // },
    // {
    //     "id": 4,
    //     "name": 'Soil Heat Flux',
    //     "icon":"stroopwafel",
    //     "ismap":true,

    // },

    // {
    //   "id": 2,
    //   "name": "Layers",
    //   "icon":"stroopwafel",
    //   "children": [
    //     {
    //       "id": 3,
    //       "name": 'Net Radiation',
    //       "icon":"stroopwafel",
    //       "ismap":true,
    //       "defaultLayer":"NHP_ISRO_DNR_20190105"
    //     },
    //     {
    //       "id": 4,
    //       "name": 'Soil Heat Flux',
    //       "icon":"stroopwafel",
    //       "ismap":true,
    //       "defaultLayer":"NHP_ISRO_DSHF_20190105"
    //     },
    //     {
    //       "id": 5,
    //       "name": 'Evapotranspiration',
    //       "icon":"stroopwafel",
    //       "ismap":true,
    //       "defaultLayer":"NHP_ISRO_Daily_Evapotranspiration20190105"
    //     },

    //   ]
    // },
    // {
    //   "id": 2,
    //   "name": "Layers",
    //   "icon":"stroopwafel",
    //   "children": [
    //     {
    //       "id": 3,
    //       "name": 'Net Radiation',
    //       "icon":"stroopwafel"
    //     },
    //     {
    //       "id": 4,
    //       "name": 'Soil Heat Flux',
    //       "icon":"stroopwafel"
    //     },

    //   ]
    // },

    // {
    //   "id": 9,
    //   "name": "menu3",
    //   "icon":"stroopwafel",
    //   "children": [
    //     {
    //       "id": 10,
    //       "name": "menu3 child1",
    //       "icon":"stroopwafel",
    //       "children": [
    //             {
    //               "id": 163,
    //               "name": "menu3 child1 child1",
    //               "icon":"stroopwafel"
    //             },
    //             {
    //               "id": 166,
    //               "name": "menu3 child1 child2",
    //               "icon":"stroopwafel"
    //             }
    //           ]
    //     },
    //     {
    //       "id": 11,
    //       "name": "menu3 child2",
    //       "icon":"stroopwafel",
    //       "children": [
    //             {
    //               "id": 165,
    //               "name": "menu3 child2 child3",
    //               "icon":"stroopwafel"
    //             },
    //             {
    //               "id": 164,
    //               "name": "menu3 child2 child3",
    //               "icon":"stroopwafel",
    //               "children":[
    //                 {
    //                   "id": 165,
    //                   "name": "menu3 child2 child3 child1",
    //                   "icon":"stroopwafel"
    //                 },
    //                 {
    //                   "id": 167,
    //                   "name": "menu3 child2 child3 child2",
    //                   "icon":"stroopwafel"
    //                 }
    //               ]
    //             }
    //         ]
    //     }
    //   ]

    // }
  ],
};
